import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AdSense from 'react-adsense';
import { useParams } from "react-router-dom";
import { alert_error, alert_success } from './../../AppContext';
import { Cookies } from './../../index.js';
import { ClipLoader } from "react-spinners";

const InviteFriends = () => {
    const [nutxuly, setnutxuly] = useState(0);
    const [nutorder, setnutorder] = useState('✔️ Click to Confirm');
    const { slug_1 } = useParams();
    const [info, set_info] = useState(null); // chứa toàn bộ JSON
    const [tools, set_tools] = useState([]); // chứa danh sách tools

    const laythongtin = (apikey, service) => {
        axios
            .post('https://hust.media/jop/auto_tools/history_2.php', {
                apikey: apikey,
                service: service
            })
            .then(response => testFunction4(response))
            .catch(error => console.log('Lỗi lấy thông tin: ' + error));
    };

    const testFunction4 = (response) => {
        console.log(response.data);
        const info = response.data;
        if (info && info.data) {
            set_info(info);
            set_tools(info.data); // mảng danh sách tools thuê
        }
    };

    const laydulieu = () => {
        const apiKey = Cookies.get('apikey');
        if (apiKey) {
            laythongtin(apiKey, 'getinfo');
        } else {
            console.log('Không có API key.');
        }
    };

    useEffect(() => {
        laydulieu();
    }, []);

    function handleSubmit(event) {
        setnutxuly(0);
        const apikey = Cookies.get('apikey');
        event.preventDefault();

        setnutxuly(1);
        setnutorder('Please wait a moment 😊');
        if (!apikey) {
            alert_error('Please điền đầy đủ thông tin');
            setnutxuly(0);
            setnutorder('điền đủ thông tin');
            return;
        }
        axios
            .post('https://hust.media/jop/referral/pay.php', { apikey })
            .then(response => testFunction(response))
            .catch(error => console.log(error));
    }

    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        setnutorder('đặt tiếp luôn nào');
        setnutxuly(0);
        if (status === 0) alert_error(info.message);
        else if (status === 1) alert_success(info.message);

        if (info.redirect) {
            setTimeout(() => {
                window.location.href = info.redirect;
            }, 1700);
        }
    }

    return (
        <div className="mt-2 mx-2">
            {!info ? (
                <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">
                    <ClipLoader size={90} color="#8a2be2" />
                </div>
            ) : (
                <div className="max-w-xl mt-2 mx-2 mx-auto">
                    {/* Thời gian còn lại */}
                    {tools.length > 0 ? (
                        tools.map((tool, index) => (
                            <div key={index} className="max-w-xl mt-2 mx-2 mx-auto">
                                {/* Thời gian còn lại */}
                                {/* Tools đang thuê */}
                                <div className="bg-white p-2 rounded-md shadow-md mb-0">
                                    <div className="bg-gray-100 rounded-md shadow-md border-1 border-purple-300">
                                        <div className="text-base mt-0 text-center font-semibold">
                                            Tools đang thuê:
                                        </div>
                                        <div className="mb-0 text-center text-lg text-purple-700">
                                            {tool.servicename}
                                        </div>

                                        {/* Trạng thái */}
                                        <div className="text-center text-sm mt-0">
                                            {tool.status === 'error' ? (
                                                <span className="text-red-500">❌ {tool.message}</span>
                                            ) : (
                                                <span className="text-green-600">✅ {tool.message}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="bg-white p-2 rounded-md shadow-md mb-0">
                                    <div className="bg-gray-100 rounded-md shadow-md border-1 border-purple-300">
                                        <div className="text-base mt-0 text-center font-semibold">
                                            Thời gian còn lại:
                                        </div>
                                        <div className="text-center text-lg text-purple-700">
                                            {tool.date} ngày
                                        </div>
                                    </div>
                                </div>

                                {/* Ngày hết hạn */}
                                <div className="bg-white p-2 rounded-md shadow-md mb-0">
                                    <div className="bg-gray-100 rounded-md shadow-md border-1 border-purple-300">
                                        <div className="text-base mt-0 text-center font-semibold">
                                            Ngày hết hạn:
                                        </div>
                                        <div className="mb-2 text-center text-lg text-purple-700">
                                            {tool.time}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        ))
                    ) : (
                        <div className="text-center text-gray-500 mt-4">Không có tools nào</div>
                    )}


                    {/* Quảng cáo */}
                    <div className="cards mt-2">
                        <AdSense.Google
                            client="ca-pub-4574266110812955"
                            slot="3259681051"
                            style={{ display: 'block' }}
                            format="auto"
                            responsive="true"
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default InviteFriends;
